import { createSelector } from '@ngrx/store';

import { selectFehHomebatteryState } from '../feh-homebattery.state';
import { homebatteryQuestionnaireKey } from './homebattery-questionnaire.reducer';

const selectHomebatteryQuestionnaire = createSelector(
  selectFehHomebatteryState,
  (state) => state[homebatteryQuestionnaireKey]
);

export const selectHomebatteryQuestionnaireStructure = createSelector(
  selectHomebatteryQuestionnaire,
  (state) => state.structure
);

export const selectHomebatteryQuestionnaireCurrentQuestion = createSelector(
  selectHomebatteryQuestionnaire,
  (state) => state.currentQuestion
);

export const selectHomebatteryQuestionnaireAnswers = createSelector(
  selectHomebatteryQuestionnaire,
  (state) => state.answers
);

export const selectHomebatteryQuestionnaireHasPreviousQuestion = createSelector(
  selectHomebatteryQuestionnaire,
  (state) => state.history.length > 0
);
